<template>
  <div @click="resetFilters">
    <slot></slot>
  </div>
</template>

<script>
export default {
  methods: {
    resetFilters() {
      EventDispatcher.fire('resetFilters');
    }
  }
}
</script>

<style lang="scss" scoped>
  div {
    cursor: pointer;
    width: 100%;
    height: 100%;
  }
</style>


